import * as ngCore from '@angular/core'
import * as ents from '@attain-apps/entities'
import * as ec from '@attain-apps/fe/web/main/lib/entity-collection'
import * as rxjs from 'rxjs'

import * as gql from './gql'
import type { TypeParams } from './types'

/** Space cluster occupants API */
@ngCore.Injectable()
export class Api implements ec.models.Api<TypeParams> {
  /** @inheritdoc */
  public list = ec.models.Api.list.using.everything<TypeParams>(context => {
    if (!context) {
      return rxjs.of([])
    }

    return gql.queries.clusterOccupants.executor({ ...context })
  })

  /** @inheritdoc */
  public create: ec.models.Api<TypeParams>['create'] = (
    context,
    { employeeIds },
  ) => {
    if (!context) {
      return rxjs.of(undefined)
    }
    return gql.mutations.addClusterOccupants.executor({
      ...context,
      employeeIds,
    })
  }

  /** @inheritdoc */
  public delete: ec.models.Api<TypeParams>['delete'] = (context, id) => {
    if (!context) {
      return rxjs.of(undefined)
    }
    return gql.mutations.removeClusterOccupant.executor({
      ...context,
      employeeId: id,
    })
  }

  /** @inheritdoc */
  public update: ec.models.Api<TypeParams>['update'] = (
    context,
    { id, updates },
  ) => {
    if (!context) {
      return rxjs.of(undefined)
    }

    const payrollIds = (updates.payrolls ?? [])
      .filter(ents.extra.space.Record.Occupant.Payroll.isFullyAssigned)
      .flatMap(p => p.payrollIds)

    return gql.mutations.allocateClusterOccupantPayrolls.executor({
      ...context,
      employeeId: id,
      payrollIds,
    })
  }
}
